import React, { useEffect, useState } from "react";
import img from "../../Images/Rectangle 55.png";
import img1 from "../../Images/Rectangle 55 (1).png";
import img2 from "../../Images/Rectangle 55 (2).png";
import img3 from "../../Images/Rectangle 55 (3).png";
import facebook from "../../Images/Group 65.png";
import instagram from "../../Images/Group 66.png";
import thread from "../../Images/Group 67.png";
import Slider from "react-slick";
import HomeService from "../../Services/HomeService";
const WallofFame = () => {
  const [wallOfFame, setWallOfFame] = useState([]);
  const fetchWallOfFame = async () => {
    try {
      const res = await HomeService?.getWallOfFame();
      console.log("Wall of fame", res);
      if (res?.status) {
        setWallOfFame(res?.data);
      } else {
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchWallOfFame();
  }, []);
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 899,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  // console.log('wallOfframe',wallOfFame);
  
  return (
    <>
      <div className="wall_of_fame_wrapper">
        <div className="search_cities_div">
          <h1>Winners Wall of Fame</h1>
          <p>
            Top brokers. Big wins. Proud moments — on our Wall of Excellence!
          </p>
          <div className="wall_of_fame_cards_wrapper">
            <Slider {...settings}>
              {wallOfFame?.map((e, i) => (
                <div className="wall_of_fame_card">
                  <div className="back_social_icons">
                    <img src={facebook} />
                    <img src={instagram} />
                    <img src={thread} />
                  </div>
                  <img className="wall_of_fame_img" src={e?.image} />
                  <div className="wall_of_fame_content">
                    <span>{e?.name}</span>
                    <small>{e?.designation}</small>
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          {/* <button
            style={{
              padding: "15px 50px",
              borderRadius: "5px",
              border: "none",
              background: "#003468",
              color: "#fff",
              fontSize: "17px",
              fontWeight: "500",
              display: "block",
              marginInline: "auto",
              marginTop: "50px",
            }}
          >
            Learn More
          </button> */}
        </div>
      </div>
    </>
  );
};

export default WallofFame;
